module.exports = __webpack_public_path__ + "static/media/fr-stephen.4348fb6a.jpg";